import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import AddCircle from "@mui/icons-material/AddCircleRounded";

import _ from "lodash";
import ApiUserTransaction from "../../../core/api/api.userTransaction";
import ApiSupplier from "../../../core/api/api.supplier";
import ApiHome from "../../../core/api/api.home";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import CreateSupplierWithdrawalModal from "./CreateSupplierWithdrawalModal";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, MenuItem } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import SelectComponent from "../_Components/ReactSelectComponent";
import { tools } from "../../../core/utils/tools";
import { ViewModal } from "./ViewModal";
import GlobalFormControl from "../_Components/GlobalFormControl";

const SupplierTransactions = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const [supplierList, setSupplierList] = useState();
  const [supplierTransactionsList, setSupplierTransactionsList] = useState({});
  const [showCreateTransactionModal, setShowCreateTransactionModal] = useState(false);
  const [showModalSupplierTransaction, setShowModalSupplierTransaction] = useState(false);
  const [selectedSupplierTransaction, setSelectedSupplierTransaction] = useState(null);
  const [balanceTypes, setBalanceTypes] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : getValues("pageNumber");

  useEffect(() => {
    (async () => {
      try {
        const balanceTypes = await ApiHome.getEnums({ enumName: "BalanceType" });
        setBalanceTypes(balanceTypes.data);
        // دریافت لیست همه تامین کننده ها
        const suppliersList = await ApiSupplier.getAllSuppliersName();
        setSupplierList(suppliersList);
        // دریافت لیست تراکنش های تامین کننده
        const supplierTransactionsList = await ApiUserTransaction.getAllSupplierTransactions({
          fromDate: searchParams.get("fromDate"),
          toDate: searchParams.get("toDate"),
          fromAmount: searchParams.get("fromAmount"),
          toAmount: searchParams.get("toAmount"),
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          basketId: searchParams.get("basketId"),
          status: searchParams.get("status"),
          supplierId: searchParams.get("supplierId"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setSupplierTransactionsList(supplierTransactionsList);
        setValue("totalCount", supplierTransactionsList.totalCount);

        const formInputs = [
          { name: "fromDate", type: "datePicker" },
          { name: "toDate", type: "datePicker" },
          { name: "fromAmount", type: "text" },
          { name: "toAmount", type: "text" },
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "basketId", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: false,
            data: suppliersList?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "status",
            type: "multiSelect",
            isMulti: false,
            data: balanceTypes?.data
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.basketId) && !validateNumber(data.basketId)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    if (!_.isEmpty(data.fromAmount) && !validateNumberFromAmount(data.fromAmount)) return;
    data.pageNumber = getValues("pageNumber");
    data.fromAmount =
      data.fromAmount && data.fromAmount.length > 0
        ? data.fromAmount.replaceAll(" ", "").replaceAll(",", "")
        : undefined;
    data.toAmount =
      data.toAmount && data.toAmount.length > 0 ? data.toAmount.replaceAll(" ", "").replaceAll(",", "") : undefined;
    if (data.fromDate && typeof data.fromDate === "object") {
      data.fromDate = tools.DateFormat(data.fromDate);
    }
    if (data.toDate && typeof data.toDate === "object") {
      data.toDate = tools.DateFormat(data.toDate);
    }
    data.supplierId = data.supplierId?.value;
    data.status = data.status?.value;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiUserTransaction.getAllSupplierTransactions(data);
    setSupplierTransactionsList(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/supplierTransactions?${queryString}`);
  };
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  const validateNumberFromAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };
  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5 ">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست تراکنش های کیف پول تامین کنندگان</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تراکنش های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              className=""
              onClick={() => {
                setShowCreateTransactionModal(true);
              }}
            >
              <AddCircle className="mr-1" />
             برداشت وجه
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="از تاریخ"
                                  onChange={(date) => {
                                    var toDate = getValues("toDate");
                                    onChange(date);
                                    if (!toDate || (date?.toDate && date?.toDate()?.getTime() > new Date(toDate).getTime())) {
                                      // Set the value of toDate to the same as toDate
                                      setValue("toDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberFromAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  type="search"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="supplierId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={supplierList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="تامین کننده"
                                  className="mt-5"
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="status"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={balanceTypes?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  placeholder="وضعیت"
                                  className="mt-5"
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش"
                                  size="small"
                                  margin="normal"
                                  type="search"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumber(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketId && (
                              <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-3 mt-6">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={supplierTransactionsList}
                  setShowModalSupplierTransaction={setShowModalSupplierTransaction}
                  setSelectedSupplierTransaction={setSelectedSupplierTransaction}
                />
              </Col>
            </form>
          </FormProvider>
          {/* <DevTool control={control} /> */}

          {showCreateTransactionModal && (
            <CreateSupplierWithdrawalModal
              showCreateTransactionModal={showCreateTransactionModal}
              setShowCreateTransactionModal={setShowCreateTransactionModal}
            />
          )}
          {showModalSupplierTransaction && (
            <ViewModal
              showModalSupplierTransaction={showModalSupplierTransaction}
              setShowModalSupplierTransaction={setShowModalSupplierTransaction}
              selectedSupplierTransaction={selectedSupplierTransaction}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplierTransactions;
